import cc from "classcat"

export default function SectionContainer({
  title = "",
  description = "",
  children,
  className = "text-zinc-800",
  descriptionTextColor = "",
  id = "",
  paddingSize = "large",
  width = "normal",
}) {
  return (
    <section
      className={cc([
        "relative ",
        paddingSize === "small" ? "py-8 lg:py-12" : "py-16 lg:py-24",
        className,
      ])}
      id={id}
    >
      <div
        className={cc([
          width === "wide" ? "max-w-[90rem]" : "max-w-7xl",
          "mx-auto px-4 sm:px-6 lg:px-8",
        ])}
      >
        <div className="max-w-4xl">
          {title && (
            <h2 className="whitespace-pre-line text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
              {title}
            </h2>
          )}
          {description && (
            <p
              className={cc([
                "m-0 mt-3 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl",
                descriptionTextColor || "text-zinc-800",
              ])}
            >
              {description}
            </p>
          )}
        </div>
        <div>{children}</div>
      </div>
    </section>
  )
}
